/**
 * A no-op function that returns void.
 * Useful as a placeholder or default callback.
 *
 * @returns void
 *
 * @example
 * ```ts
 * import { Void } from "@pdfking/tfunc"
 *
 * const loud = false
 * const onClick = loud ? () => console.log("clicked") : Void
 * onClick() // does nothing: loud is false
 *
 * // As a default parameter
 * const process = (callback: () => void = Void) => callback()
 * process() // does nothing either
 * ```
 */
export const Void = (): void => {}
